import { Route, Routes } from "react-router-dom";

import FreeAuthRoute from "src/routes/FreeAuthRoute";
import ProtectedRoute from "src/routes/ProtectedRoute";

import Dashboard from "src/pages/Dashboard";
import ErrorPage from "src/pages/auth/404";
import Login from "src/pages/auth/Login";
import Logout from "src/pages/auth/Logout";
import PermissionDenied from "src/pages/auth/PermissionDenied";
import WorkspacePaused from "src/pages/auth/WorkspacePaused";
import SSOLogin from "src/pages/auth/SSOLogin";
import ForgotPassword from "src/pages/forgot-password/ForgotPassword";
import ResetPassword from "src/pages/forgot-password/ResetPassword";
import RedirectToEmbed from "src/pages/RedirectToEmbed";
import AuthenticationVerify from "src/pages/forgot-password/AuthenticationVerify";
import Authorization from "src/pages/auth/authorization";
import LandingPage from "src/pages/LandingPage";
import Unsubscribe from "src/pages/unsubscribe";
import Storage from "src/pages/storage";
import EmbededWebview from "src/pages/embeded-webview";
import PrivacyPolicy from "src/pages/privacy-policy";
import Preloader from "src/components/shared/LoadingAnimations/Preloader";
import TravelDashboard from "src/pages/travel/TravelDashboard";
import TravelHelp from "src/pages/travel/TravelHelp";
import TravelPlanet from "src/pages/travel/TravelPlanet";
import TravelHome from "src/pages/travel/TravelHome";
import TravellerProfileForm from "src/pages/travel/tile-content/TravellerProfileForm";

const AppRoutes = () => {
  return (
    <Routes>
      {/* NOT PROTECTED routes */}
      <Route
        path="/"
        element={<FreeAuthRoute />}>
        <Route
          index
          element={<LandingPage />}
        />

        <Route
          path="/login"
          element={<Login />}
        />
        <Route
          path="/forgot-password"
          element={<ForgotPassword />}
        />
        <Route
          path="/forgot-password/reset-password/:token"
          element={<ResetPassword type="forgot-password" />}
        />
        <Route
          path="/token/:token"
          element={<ResetPassword type="welcome-mail" />}
        />
      </Route>

      <Route
        path="/embeded/webview"
        element={<EmbededWebview />}
      />

      <Route
        path="/privacy-policy"
        element={<PrivacyPolicy />}
      />

      <Route
        path="/contact-us"
        element={<EmbededWebview />}
      />

      <Route
        path="/sso-login"
        element={<SSOLogin />}
      />

      {/* PROTECTED routes */}
      <Route
        exact
        path="/"
        element={<ProtectedRoute />}>
        <Route
          exact
          path="/permission-denied"
          element={<PermissionDenied />}
        />

        <Route
          exact
          path="/workspace/:workspace_id/workspace-paused"
          element={<WorkspacePaused />}
        />

        <Route
          exact
          path="/workspace/:workspace_id/no-content"
          element={<PermissionDenied />}
        />
        <Route
          exact
          path="/workspace/:workspace_id/payment-required"
          element={<PermissionDenied />}
        />
        {/* <Route
          path="/workspace/:workspace_id"
          element={<Dashboard2 />}
        /> */}
        <Route
          path="/workspace/:workspace_id/embed"
          element={<Dashboard />}
        />
        <Route
          path="/workspace/:workspace_id/menu/:content_type/:content_value"
          element={<Dashboard header_menu />}
        />
        <Route
          path="/menu/page/:header_page_id"
          element={<Preloader />}
        />
        {/* Redirection routes */}
        <Route
          path="/workspace/:workspace_id/page/:page_id"
          element={<RedirectToEmbed />}
        />
        <Route
          path="/workspace/:workspace_id/group/:group_id/page/:page_id"
          element={<RedirectToEmbed />}
        />

        {/* TRAVEL ROUTES */}

        <Route
          path="/travel/dashboard"
          element={<TravelDashboard />}
        />

        <Route
          path="/travel/home"
          element={<TravelHome />}
        />

        <Route
          path="/travel/help"
          element={<TravelHelp />}
        />
        <Route
          path="/travel/greener"
          element={<TravelPlanet />}
        />
        <Route
          path="/travel/profile"
          element={<TravellerProfileForm />}
        />
      </Route>

      {/* UNIVERSAL ROUTES */}

      <Route
        path="/storage/:storage_id/:link_id"
        element={<Storage />}
      />

      <Route
        path="/authorization/:token"
        element={<Authorization />}
      />

      <Route
        path="/authentication/verify/:token"
        element={<AuthenticationVerify />}
      />

      <Route
        path="/email/unsubscribe/:token"
        element={<Unsubscribe />}
      />

      <Route
        path="/logout"
        element={<Logout sso={true} />}
      />

      <Route
        path="/logout/callback"
        element={<Logout />}
      />

      <Route
        path="*"
        element={<ErrorPage />}
      />
    </Routes>
  );
};

export default AppRoutes;
